import React from 'react';
import ActionMenu from '../../common/ActionMenu';

const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const WarehousesTab = ({ warehouses, locations, loading, onAdd, onEdit, onDelete }) => (
  <>
    <style>{spinKeyframes}</style>
    <div style={{ width: '100%' }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
        borderRadius: '0.375rem', boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)'
      }}>
        <div style={{
          padding: '0.75rem 1rem', borderBottom: '1px solid var(--border)',
          backgroundColor: 'var(--bg)', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h5 style={{ margin: 0, fontWeight: '600', color: 'var(--text-secondary)', fontSize: '1rem' }}>
            Magazyny / Sklepy
          </h5>
          <button
            style={{
              padding: '6px 12px', fontSize: '12px', fontWeight: '500',
              color: '#fff' , backgroundColor: 'var(--success)', border: '1px solid var(--success)',
              cursor: 'pointer'
            }}
            onClick={onAdd}
          >
            Dodaj magazyn
          </button>
        </div>
        <div style={{ padding: '1rem' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
              <div style={{
                display: 'inline-block', width: '2rem', height: '2rem',
                border: '3px solid var(--bg)', borderTop: '3px solid var(--info)',
                borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '1rem'
              }} />
              <div>Ladowanie...</div>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: 'var(--bg)' }}>
                    {['Nazwa', 'Kod', 'Lokalizacja', 'Typ', 'Miasto', 'Kierownik', 'Pracownicy', 'Produkty', 'Akcje'].map(h => (
                      <th key={h} style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '1px solid var(--border)', fontSize: '0.875rem', fontWeight: '600' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {warehouses.map(warehouse => (
                    <tr key={warehouse.id} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '0.75rem', fontWeight: '600' }}>{warehouse.nazwa}</td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{ backgroundColor: 'var(--bg)', color: 'var(--text-secondary)', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontFamily: 'monospace' }}>
                          {warehouse.kod_magazynu}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{ backgroundColor: 'var(--info-light)', color: 'var(--info)', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: '500' }}>
                          {locations.find(loc => loc.id === warehouse.location_id)?.nazwa || 'Brak przypisania'}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{ backgroundColor: warehouse.typ_magazynu === 'sklep' ? 'var(--info)' : 'var(--text-muted)', color: '#fff' , padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: '500' }}>
                          {warehouse.typ_magazynu}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem' }}>{warehouse.miasto || '-'}</td>
                      <td style={{ padding: '0.75rem' }}>{warehouse.kierownik_login || '-'}</td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{ border: '1px solid var(--info)', color: 'var(--info)' , padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: '500' }}>
                          {warehouse.assigned_users ? warehouse.assigned_users.length : 0}
                        </span>
                        {warehouse.assigned_users?.length > 0 && (
                          <div style={{ marginTop: '0.25rem', fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                            {warehouse.assigned_users.map(u => u.user_login).join(', ')}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{ border: '1px solid var(--success)', color: 'var(--success)' , padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: '500' }}>
                          {warehouse.liczba_produktow || 0}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        <ActionMenu actions={[
                          { icon: '✏️', label: 'Edytuj', color: 'var(--info)', onClick: () => onEdit(warehouse) },
                          { icon: '🗑️', label: 'Usuń', color: 'var(--danger)', onClick: () => onDelete(warehouse.id) },
                        ]} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  </>
);

export default WarehousesTab;
